<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search_no_name_nameen') ||
                  '分类编码/分类名称/分类名称英文搜索... '
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
              v-if="allow('A')"
              v-show="addButtonVisible"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('table_label_material_category_no') || '分类编号'"
            >
              <el-input
                v-model.trim="form.materialCategoryNo"
                :placeholder="
                  $l('table_please_input_material_category_no') ||
                    '请输入分类编号'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('table_label_material_category_name') || '分类名称'"
            >
              <el-input
                v-model.trim="form.materialCategoryName"
                :placeholder="
                  $l('table_please_input_material_category_name') ||
                    '请输入分类名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="
                $l('table_label_material_category_name_En') || '分类名称英文'
              "
            >
              <el-input
                v-model.trim="form.materialCategoryNameEn"
                :placeholder="
                  $l('table_please_input_material_category_En') ||
                    '请输入分类英文名称'
                "
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: ''
}

export default {
  props: {
    // depRow: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgRow: {},
      addButtonVisible: true
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    orgChange(row) {
      this.orgRow = row
      this.addButtonVisible = row.isLast === 'N'
      this.query()
      //console.log(this.orgRow.isLast)
      //console.log(this.addButtonVisible)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', {
        ...this.form,
        materialCategoryCode: this.orgRow.materialCategoryCode,
        parentCode: this.orgRow.parentCode
      })
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    add() {
      const { materialCategoryCode } = this.orgRow
      const { isLast } = this.orgRow
      if (!materialCategoryCode) {
        this.$message.warning(
          this.$l('form_label_tip_category') || '请先选择一个分类！'
        )
        return
      }
      if (isLast === 'Y') {
        this.$message.warning(
          this.$l('form_label_tip_is_last') || '已经是末级！'
        )
        return
      }
      this.$emit('openEditFormDialog', { type: 'add' })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
